// Pure row-selection helper (master-grid Select All polish, Item 2).
//
// Bug being fixed: the master grid's "Select all visible rows" checkbox
// must operate on the *filtered* set the grid is showing, not every row in
// the rollout. MasterGrid owns the filter (its `visibleRows` memo); it now
// passes those ids up so the parent toggles exactly that set. This helper
// is the pure set-merge the parent applies — kept separate so the
// filter-respecting contract is unit-tested without React.
//
// `next === true`  → add every id in `ids` to the selection.
// `next === false` → remove every id in `ids` from the selection.
// Ids already (de)selected are untouched; selections outside `ids` (e.g.
// rows selected under a different filter) are preserved.
export function applySelectAll(
  prev: ReadonlySet<string>,
  ids: readonly string[],
  next: boolean,
): Set<string> {
  const copy = new Set(prev);
  for (const id of ids) {
    if (next) copy.add(id);
    else copy.delete(id);
  }
  return copy;
}
